// extracted by mini-css-extract-plugin
export default {"SecuritySummaryEntry":"FphtUl8iJXYkYfYVc60W"};